module.exports = __webpack_public_path__ + "e6cc7ea51e9f8fe5a00ff61373539a1b.png";